import React from 'react';
import memoize from 'memoize-one';

const columns = memoize(() => [
  {
    name: 'Rut',
    selector: 'national_identification',
    sortable: true,
    center: true
  },
  {
    name: 'Razón Social',
    selector: 'business_name',
    sortable: true
  },
  {
    name: 'Nombre de Fantasía',
    selector: 'fantasy_name',
    sortable: true
  },
  {
    name: 'Domicilio',
    selector: 'full_address',
    grow: '2'
  },
  {
    name: 'Tipo Servicio',
    cell: () => {
      return (
        <p data-tag="allowRowEvents" className="mt-3">
          Cloud
        </p>
      );
    },
    center: true
  },
  {
    name: 'Dirección Web Fiscalización',
    cell: () => {
      return (
        <p data-tag="allowRowEvents" className="mt-3">
          https://app.peoplework.cl/login
        </p>
      );
    },
    center: true
  },
  {
    name: 'Inicio Contrato',
    selector: 'start_contract',
    sortable: true,
    center: true
  },
  {
    name: 'Fin Contrato',
    selector: 'end_contract',
    sortable: true,
    center: true
  }
]);
export default columns;
